<!-- adminlte-menu.component.html -->
<li class="nav-item"
    [ngClass]="{
      'has-treeview': isExpandable && menuItem.children?.length > 0,
      'menu-open': isMenuExtended
    }">

  <a (click)="handleMainMenuAction()"
     class="nav-link"
     [ngClass]="{ 'active': isMainActive || isOneOfChildrenActive }">
    <i class="nav-icon {{ menuItem.iconClasses }}"></i>
    <p>
      {{ menuItem.name }}
      <i *ngIf="isExpandable && menuItem.children?.length > 0"
         class="right fas fa-angle-left"
         [@rotateIcon]="isMenuExtended ? 'expanded' : 'collapsed'"></i>
    </p>
  </a>

  <ul *ngIf="isExpandable && menuItem.children?.length > 0"
      class="nav nav-treeview"
      [@expandCollapse]="isMenuExtended ? 'expanded' : 'collapsed'">
    <li *ngFor="let item of menuItem.children" class="nav-item small">
      <a [routerLink]="item.path"
         routerLinkActive="active"
         class="nav-link"
         (click)="autoOcultarMenu()">
        <i class="nav-icon {{ item.iconClasses }}"></i>
        <p>{{ item.name }}</p>
      </a>
    </li>
  </ul>
</li>